import { createPortal } from "react-dom";
import { X, FileText } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import RichContent from "@/components/RichContent";

export default function VersionsModal({ agreement, onClose }) {
  const { data: versions = [], isLoading } = useQuery({
    queryKey: ["agreement-versions", agreement.id],
    queryFn: () => api.get(`/agreements-hub/agreements/${agreement.id}/versions`).then((r) => r.data),
  });
  return createPortal(
    <div className="fixed inset-0 z-[210] bg-black/40 flex items-end sm:items-center justify-center sm:p-4" data-testid="agreement-versions">
      <div className="bg-[#FDFBF7] w-full sm:max-w-2xl max-h-[90vh] overflow-y-auto rounded-t-3xl sm:rounded-3xl p-5 sm:p-7">
        <div className="flex items-start justify-between mb-4">
          <h3 className="font-serif text-2xl text-[#1A242B]">Version history · {agreement.title}</h3>
          <button onClick={onClose} aria-label="Close" className="h-10 w-10 grid place-items-center rounded-full hover:bg-black/5" data-testid="agreement-versions-close"><X size={18} /></button>
        </div>
        {isLoading ? <p className="text-sm text-[#8FA89B]">Loading…</p> : versions.length === 0 ? (
          <p className="text-sm text-[#4A5D6B]">No saved versions yet.</p>
        ) : versions.map((v) => (
          <details key={v.id} className="rounded-xl border border-[#E5E0D8] bg-white p-4 mb-2" data-testid={`agreement-version-${v.version}`}>
            <summary className="cursor-pointer text-sm text-[#1A242B]">
              <b>Version {v.version}</b> · {String(v.created_at).slice(0, 10)} · {v.signed_count} signed
            </summary>
            {v.pdf_path && <a href={`/api/files/${v.pdf_path}`} target="_blank" rel="noreferrer" className="mt-3 inline-flex items-center gap-1.5 text-sm text-[#144F75] underline"><FileText size={14} /> {v.pdf_filename || "PDF document"}</a>}
            <RichContent text={v.content} className="mt-3 text-sm text-[#4A5D6B] leading-relaxed" />
          </details>
        ))}
      </div>
    </div>,
    document.body,
  );
}
